import { render, staticRenderFns } from "./AdminBulkUploadTab.vue?vue&type=template&id=9f0eb2e6&scoped=true"
import script from "./AdminBulkUploadTab.vue?vue&type=script&lang=js"
export * from "./AdminBulkUploadTab.vue?vue&type=script&lang=js"
import style0 from "./AdminBulkUploadTab.vue?vue&type=style&index=0&id=9f0eb2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0eb2e6",
  null
  
)

export default component.exports